import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard } from '../../Components/Common/DashboardKit';

/**
 * Engineering module landing page.
 *
 * UI-only refactor (Pass 1):
 *  - Replaced the video-based <ComingSoon> with <ComingSoonCard>.
 *  - Removed dead imports that were never referenced in the markup
 *    (api, DigitalClock, avatar3, react-toastify, etc.).
 *
 * Route is wrapped in <RoleProtected requireManager> in allRoutes.js.
 */
const Engineering = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-pencil-ruler-2-line"
                        eyebrow="Design"
                        title="Engineering"
                        subtitle="Drawings, BOMs, and design workflow"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Engineering" },
                        ]}
                    />

                    <ComingSoonCard
                        icon="ri-pencil-ruler-2-line"
                        title="Engineering workspace is coming soon"
                        message="Drawings, BOMs, and engineering change tracking will be unified here. For now, please continue using the existing tools."
                        tone="success"
                        features={[
                            "Drawing browser by part number",
                            "BOM lookup and revision history",
                            "Engineering change notice (ECN) shortcuts",
                            "Drawing approval workflow",
                        ]}
                        contact="Reach out to the Engineering team for ETA updates."
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Engineering;
